import { GamesCardListSkeleton } from "@/components/webview/games/core/GamesCardListSkeleton";
import { useTrans } from "@/utils/useTrans";
import { LayoutGamesWebView } from "@/components/webview/games/layout/LayoutGamesWebView";
import dynamic from "next/dynamic";
import Link from "next/link";
import { WEBVIEW_ROUTES } from "@/components/webview/route";
import { GamesPlatformWebView } from "@/components/webview/games/constants/gameResellWebViewConstants";
import { Button1 } from "@/components/webview/games/typograpy/typograpy-webview";

const LazyGamesNewGamesWebView = dynamic<{
  className?: string;
  platform?: GamesPlatformWebView;
}>(() => import("../GamesNewGamesWebView"), {
  ssr: false,
  loading: () => (
    <LayoutGamesWebView
      className={"py-4"}
      header={<h2 className="px-4">{"New Games"}</h2>}
      contents={<GamesCardListSkeleton cardCount={9} />}
    />
  ),
});

const PcGameLazySectionsWebView = () => {
  const { t } = useTrans(["games"]);
  return (
    <div className="flex flex-col gap-[38px] bg-black">
      <LazyGamesNewGamesWebView platform={GamesPlatformWebView.Pc} />

      <LayoutGamesWebView
        className="px-4 pb-10"
        contents={
          <Link
            href={`${WEBVIEW_ROUTES.webviewSearch}/?filter=${GamesPlatformWebView.Pc}&sort=monthlyPlayCount&only-sellable=false`}
            className="flex h-[50px] w-full items-center justify-center rounded-md bg-[#FFD900] text-black"
          >
            <Button1>{t("See All PC Games")}</Button1>
          </Link>
        }
      />
    </div>
  );
};

export default PcGameLazySectionsWebView;
